import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function VippsMock() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await api.post(`/payments/vipps/complete?session_id=${encodeURIComponent(sessionId)}`);
      nav(`/betaling/vellykket?session_id=${encodeURIComponent(sessionId)}`);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      setBusy(false);
    }
  };

  return (
    <div className="tk-container py-24 max-w-md text-center" data-testid="vipps-mock-page">
      <Smartphone size={48} className="mx-auto mb-4 text-orange-500" />
      <p className="tk-overline mb-2 text-orange-600">DEMO: VIPPS BETALING</p>
      <h1 className="text-2xl font-semibold mb-2">Bekreft betaling med Vipps</h1>
      <p className="text-sm text-slate-500 mb-8">
        Dette er en simulert Vipps-skjerm for v1. Trykk «Bekreft» for å fullføre betalingen.
      </p>
      <button onClick={confirm} disabled={busy} className="tk-btn-accent w-full justify-center" data-testid="vipps-confirm-btn">
        {busy ? "Behandler …" : "Bekreft betaling"}
      </button>
    </div>
  );
}
